import { ContentWrapper } from './contact_us.styles';

export default function ContactUs() {
  return (
    <ContentWrapper>
      <p>
        Sweet Factory Store sp. z o.o.
        <br />
        Ulica Jana Jerzego Haffnera 6
        <br />
        81-717 Sopot
      </p>

      <p>NIP 9571143884</p>

      <h3>Dane kontaktowe</h3>

      <p>
        <strong>Dział obsługi klienta:</strong>
        <br />
        Adres email: <a href="mailto:kontakt@sweetfactorystore.pl">kontakt@sweetfactorystore.pl</a>
      </p>
    </ContentWrapper>
  );
}
